import React from 'react';
import { EventForm } from 'Components/widgets/event-form/EventForm';
import { addTranslationKeys } from 'Src/i18n';
import type { EventResortProps } from './EventFormLine.utils';
import { getEventFormResorts, getEventFormRegions } from './EventFormLine.utils';
export type EventFormTranslationProps = {
  formTitle: string;
  formButton: string;
  packageSection: {
    title: string;
    eventTypeLabel: string;
    eventTypePlaceholder: string;
    eventTypeOptions: Array<{
      value: string;
      name: string;
    }>;
    numberOfParticipantsLabel: string;
    numberOfParticipantsPlaceholder: string;
    packageServicesSection: {
      packageServicesLabel: string;
      roomsCheckboxLabel: string;
      roomsInputLabel: string;
      roomsInputPlaceholder: string;
      transportationCheckboxLabel: string;
      transportationInputLabel: string;
      transportationInputPlaceholder: string;
      meetingRoomsCheckboxLabel: string;
      otherServicesCheckboxLabel: string;
      otherServicesInputLabel: string;
      otherServicesInputPlaceholder: string;
    };
  };
  staySection: {
    title: string;
    destinationLabel: string;
    destinationPlaceholder: string;
    resortLabel: string;
    resortPlaceholder: string;
    datesLabel: string;
    datesPlaceholder: string;
    datesFormat: string;
    flexibleDatesLabel: string;
  };
  userSection: {
    title: string;
    companyLabel: string;
    companyPlaceholder: string;
    salutationLabel: string;
    salutationPlaceholder: string;
    salutationOptions: Array<{
      value: string;
      name: string;
    }>;
    firstNameLabel: string;
    firstNamePlaceholder: string;
    lastNameLabel: string;
    lastNamePlaceholder: string;
    emailLabel: string;
    emailPlaceholder: string;
    phoneLabel: string;
    phonePlaceholder: string;
    addressLabel: string;
    streetLabel: string;
    streetPlaceholder: string;
    postcodeLabel: string;
    postcodePlaceholder: string;
    cityLabel: string;
    cityPlaceholder: string;
    countryLabel: string;
    countryPlaceholder: string;
    personalInformationOptinLabel: string;
    displayAddressFields: boolean;
  };
  commentSection: {
    title: string;
    commentLabel: string;
    commentPlaceholder: string;
    optinLabel: string;
    emailOptinLabel: string;
    smsOptinLabel: string;
    phoneOptinLabel: string;
  };
  formSuccess: EventFormResponseTranslations;
  formError: EventFormResponseTranslations;
};
type EventFormProps = EventFormTranslationProps & {
  resorts: Array<EventResortProps>;
};
export const EventFormLine = (props: EventFormProps) => {
  addTranslationKeys({
    eventForm: props,
  });
  const {
    formError,
    formSuccess,
    resorts,
    packageSection: { eventTypeOptions },
    userSection: { displayAddressFields, salutationOptions },
  } = props;
  const formResorts = getEventFormResorts(resorts);
  const formRegions = getEventFormRegions(formResorts);
  return (
    <EventForm
      type="classic"
      displayAddressFields={displayAddressFields}
      typeOptions={eventTypeOptions}
      formError={formError}
      formSuccess={formSuccess}
      regions={formRegions}
      resorts={formResorts}
      userSalutationOptions={salutationOptions}
    />
  );
};
